import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Prefrence } from './interfaces';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';

@Component({
  selector: 'app-pierhippla',
  templateUrl: './pierhippla.component.html',
  styleUrls: ['./pierhippla.component.css'],
})
export class PIERHIPPLAComponent implements OnInit{
  //contextCd: string = '';
  //subContextCd: string = '';
  preference: Prefrence | null = null;
  email: string | undefined ='';
  tollfreeNo: string | undefined |  null ='';
  faxNo: string | undefined | null='';
  errorMessageIntialData: string = '';
  address: string='';
  emailTo: string='';
  logoImage: any;
  applicationPDF: any;

  ngOnInit(): void {
    this.logoImage = 'app/module/pierhippla/assets/img/LA_Header.jpg';
    //this.contextCd = this.route.snapshot.url[0].path;
    //this.subContextCd = this.contextCd.substring(8);

    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;
        this.applicationPDF = this.preference.paperApplication;
        this.faxNo= ValidationService.formatPhoneNumber(preferences.preferenceValues?.['FAX_NUM']);
        this.tollfreeNo= ValidationService.formatPhoneNumber(preferences.preferenceValues?.['TOLL_FREE_NUM']);
        this.email= preferences.preferenceValues?.['EMAIL_ID'];
        this.emailTo='mailto:'+this.email;
        this.address=''+preferences.preferenceValues?.['STATE_PROGRAM']+', '+preferences.preferenceValues?.['ADDRESS1_TXT']+', '+preferences.preferenceValues?.['ADDRESS2_TXT']+', '+preferences.preferenceValues?.['CITY_TXT']+', '+preferences.preferenceValues?.['STATE_CD']+' '+preferences.preferenceValues?.['ZIP_CODE'];
      }, 
      error:  (err: HttpErrorResponse) => {this.logger.log(err.message);
        const msg = 'Unable to get the Preference details: '+err.message;
        this.errorMessageIntialData = msg;

      }});


  }

  openPaperApplication(){
    let bytes = this.applicationPDF;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.download = 'PaperApplication.pdf';
    anchor.click();
  }

    base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  constructor( private route: ActivatedRoute,
    private dataService: DataService,
    private logger: LoggerService,
    ) {}



}
